import { baseKeymap, chainCommands } from "prosemirror-commands";
import { keymap } from "prosemirror-keymap";
import { Schema } from "prosemirror-model";
import { splitListItem } from "prosemirror-schema-list";
import { Plugin } from "prosemirror-state";
import { Extension } from "@smartsuite/smartdoc";

export class MiniEditorExtension extends Extension {
  addPlugins(schema: Schema, plugins: Plugin[]): Plugin[] {
    return plugins.concat([
      keymap({
        "Shift-Enter": chainCommands(splitListItem(schema.nodes.list_item), baseKeymap.Enter),
        Enter: () => true,
        Escape: () => true,
      }),
    ]);
  }
}
